<script setup lang="ts">
// TODO провести рефакторинг
import './style.scss';

import { UiIcon, UiImg } from '@shared/ui';
import type { UiAvatarProps } from '@shared/ui';
import { NuxtLink } from '#components';

const className = 'ui-avatar';

const {
  tag = 'span',
  icon,
  text,
  href,
  target = '_self',
  rel,
  src,
  alt = '',
  size = 'md',
  type = 'round',
} = defineProps<UiAvatarProps>();

const emit = defineEmits<{
  (e: 'error', event: Event): void;
}>();

const hasLoadError = ref(false);

const getTagName = computed<string | typeof NuxtLink>(() => (tag === 'a' ? NuxtLink : tag));

const getRel = computed<string | null>(() => rel ?? null);

const getImgSize = computed<number>(() => {
  switch (size) {
    case 'xs':
      return 18;
    case 'sm':
      return 20;
    case 'md':
      return 30;
    case 'lg':
      return 38;
    case 'xl':
      return 46;
    case 'xxl':
      return 62;
    case 'xxxl':
      return 94;

    default:
      return 30;
  }
});

const handleError = (e: Event) => {
  hasLoadError.value = true;
  emit('error', e);
};
</script>

<template>
  <component
    :is="getTagName"
    :href="href"
    :target="tag === 'a' ? target : null"
    :rel="getRel"
    :class="[
      className,
      {
        [`${className}_action`]: ['a', 'button'].includes(tag),
        [`${className}_${size}`]: size,
        [`${className}_${type}`]: type,
      },
    ]"
  >
    <UiImg
      v-if="src && !hasLoadError"
      tag="span"
      :src="src"
      :alt="alt"
      :width="getImgSize"
      :class="`${className}__img`"
      @error="handleError"
    />

    <UiIcon
      v-else-if="icon"
      :name="icon"
      :class="`${className}__icon`"
    />
    <span
      v-else-if="text"
      :class="`${className}__text`"
    >{{ text }}</span>
    <span
      v-if="alt"
      class="sr-only"
    >{{ alt }}</span>
  </component>
</template>
